import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})

export class FormService {

  constructor(private translate: TranslateService) { }
  
  getErrorMessageForFormControl(controlName:string, form: FormGroup) {
    if(form.get(controlName)!.hasError('required')) {
      return this.translate.instant('FORM_ERROR_REQUIRED_MESSAGE');
    }
    if(form.get(controlName)!.hasError('minlength')) {
      return this.translate.instant('FORM_ERROR_MINLENGTH_MESSAGE', {minLength: form.get(controlName)!.getError('minlength')!.requiredLength});
    }
    if(form.get(controlName)!.hasError('email')) {
      return this.translate.instant('FORM_ERROR_EMAIL_MESSAGE');
    }
    if(controlName === 'personnalData.password' && form.get(controlName)!.hasError('pattern')) {
      return this.translate.instant('FORM_ERROR_PASSWORD_MESSAGE');
    }
    if(form.get(controlName)!.hasError('pattern')) {
      return this.translate.instant('FORM_ERROR_VALID_MESSAGE');
    }
    if(form.get(controlName)!.hasError('requiredTrue')) {
      return 'Veuillez accepter les conditions';
    }
    // Check for password mismatch at the form group level
    if((controlName === 'personnalData.confirmation' || controlName === 'confirmation') && form.get(controlName)!.parent?.hasError('passwordMismatch')) {
      return this.translate.instant('PASSWORD_MISMATCH');
    }
    return '';
  }
  
}